var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire"}},[(_vm.isDisplayMenu)?[_c('div',{staticClass:"main"},[_c('toolbar',{attrs:{"activeLinkName":_vm.linkName}}),_c('div',{staticClass:"adaptive"},[_c('transition',{attrs:{"name":"page"}},[_c('router-view')],1)],1)],1)]:[(_vm.showComponent)?_c('router-view'):_vm._e()]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }